export default {
  textColor: 'brandOne20',
  buttonStyle: 'secondaryInverseOutline',
  teamReference: 'Crufts Pet Insurance UK',
} as const;
